export default __webpack_public_path__ + "static/media/logo_uhul2.cfd0199d.jpg";